'use client';

import { c as _c } from "react/compiler-runtime";
import type { Project } from 'content-collections';
import { cn } from 'cn';
import { motion, useInView } from 'motion/react';
import { useTranslations } from 'next-intl';
import { useRef } from 'react';
import { buttonVariants } from '@/components/ui/button';
import { Link } from '@/components/ui/link';
import { ProjectCard } from '../project-card';
const variants = {
  initial: {
    y: 40,
    opacity: 0
  },
  animate: {
    y: 0,
    opacity: 1
  }
};
type SelectedProjectsProps = {
  projects: Project[];
};
export function SelectedProjects(props) {
  const $ = _c(26);
  const {
    projects
  } = props;
  const projectsRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      once: true,
      margin: "-100px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isInView = useInView(projectsRef, t0);
  const t = useTranslations();
  const t1 = isInView ? "animate" : "initial";
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      duration: 0.5
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      y: 30,
      opacity: 0
    };
    t4 = {
      y: 0,
      opacity: 1
    };
    t5 = {
      duration: 0.3
    };
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t) {
    t6 = t("homepage.selected-projects.title");
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <motion.h2 className="text-center text-3xl font-semibold" initial={t3} animate={t4} transition={t5}>{t6}</motion.h2>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t10;
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      y: 40,
      opacity: 0
    };
    t9 = {
      y: 0,
      opacity: 1
    };
    t10 = {
      duration: 0.3
    };
    $[9] = t10;
    $[10] = t8;
    $[11] = t9;
  } else {
    t10 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== projects) {
    t11 = projects.map(_temp);
    $[12] = projects;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11) {
    t12 = <motion.div className="mt-12 grid gap-4 md:grid-cols-2" initial={t8} animate={t9} transition={t10}>{t11}</motion.div>;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cn(buttonVariants({
      variant: "outline"
    }));
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t) {
    t14 = t("homepage.selected-projects.more");
    $[17] = t;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t14) {
    t15 = <div className="my-8 flex items-center justify-center"><Link href="/projects" className={t13}>{t14}</Link></div>;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t1 || $[22] !== t12 || $[23] !== t15 || $[24] !== t7) {
    t16 = <motion.div initial="initial" animate={t1} variants={variants} ref={projectsRef} transition={t2} className="relative my-24">{t7}{t12}{t15}</motion.div>;
    $[21] = t1;
    $[22] = t12;
    $[23] = t15;
    $[24] = t7;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  return t16;
}
function _temp(project) {
  return <ProjectCard key={project.slug} project={project} featured={true} lazy={false} />;
}